'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_Dashboard$RankingRow(label, total, rate, select) {
  this.wK = null;
  this.tC = 0;
  this.Cq = null;
  this.Cr = null;
  this.wK = label;
  this.tC = total;
  this.Cq = rate;
  this.Cr = select;
}
export { $c_Lpresto_Dashboard$RankingRow as $c_Lpresto_Dashboard$RankingRow };
$p = $c_Lpresto_Dashboard$RankingRow.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_Dashboard$RankingRow;
/** @constructor */
function $h_Lpresto_Dashboard$RankingRow() {
}
export { $h_Lpresto_Dashboard$RankingRow as $h_Lpresto_Dashboard$RankingRow };
$h_Lpresto_Dashboard$RankingRow.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__hashCode__I("RankingRow"));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().B(this.wK));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, this.tC);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().B(this.Cq));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().B(this.Cr));
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().al(acc, 4);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_Dashboard$RankingRow)) {
    if (((this.tC === x$0.tC) && (this.wK === x$0.wK))) {
      var x = this.Cq;
      var x$2 = x$0.Cq;
      var $x_1 = ((x === null) ? (x$2 === null) : x.i(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$3 = this.Cr;
      var x$4 = x$0.Cr;
      return ((x$3 === null) ? (x$4 === null) : x$3.i(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 4;
});
$p.s = (function() {
  return "RankingRow";
});
$p.j = (function(n) {
  switch (n) {
    case 0: {
      return this.wK;
      break;
    }
    case 1: {
      return this.tC;
      break;
    }
    case 2: {
      return this.Cq;
      break;
    }
    case 3: {
      return this.Cr;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lpresto_Dashboard$RankingRow(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.i5)));
}
export { $isArrayOf_Lpresto_Dashboard$RankingRow as $isArrayOf_Lpresto_Dashboard$RankingRow };
var $d_Lpresto_Dashboard$RankingRow = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Dashboard$RankingRow, "presto.Dashboard$RankingRow", ({
  i5: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_Dashboard$RankingRow as $d_Lpresto_Dashboard$RankingRow };
//# sourceMappingURL=presto.-Dashboard$-Ranking-Row.js.map
